import React, { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  helperText?: string;
  endAdornment?: React.ReactNode;
  error?: string;
  fullWidth?: boolean;
}

export const Input: React.FC<InputProps> = ({
  label,
  helperText,
  endAdornment,
  error,
  fullWidth = false,
  className,
  id,
  ...props
}) => {
  const inputId = id || Math.random().toString(36).substring(2, 9);
  const widthClass = fullWidth ? 'w-full' : '';
  
  const baseInputClasses = 'rounded-md border-2 px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-medium';
  const errorInputClasses = error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : '';
  
  return (
    <div className={`${widthClass}`}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-semibold text-gray-900 dark:text-white mb-1"
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={inputId}
          className={`${baseInputClasses} ${errorInputClasses} ${className || ''} ${endAdornment ? 'pr-10' : ''} bg-white text-black dark:bg-gray-800 dark:text-white border-gray-400 dark:border-gray-500`}
          {...props}
        />
        {endAdornment && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            {endAdornment}
          </div>
        )}
      </div>
      {helperText && !error && (
        <p className="mt-1 text-xs text-gray-600 dark:text-gray-200 font-medium">{helperText}</p>
      )}
      {error && (
        <div className="mt-2 p-3 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-md">
          <p className="text-sm text-red-800 dark:text-red-300 font-medium">{error}</p>
        </div>
      )}
    </div>
  );
};

export default Input